export const PRESCRIPTION_TYPE = 1
export const REPORT_TYPE = 2


// WEBPACK FOOTER //
// ./src/constants/db/patientFiles.js